export default {"src":"/_next/static/media/burger_close.942a4644.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};